import { useLayoutEffect, useState } from "react";

const screens = {
  sm: "640px",
  md: "768px",
  lg: "1024px",
  xl: "1280px",
  "2xl": "1536px",
} as const;

type Breakpoint = keyof typeof screens;

const matches = (breakpoint: Breakpoint) => {
  const value = screens[breakpoint] ?? "999999px";

  const query = window.matchMedia(`(min-width: ${value})`);

  return query.matches;
};

export const useBreakpoint = (breakpoint: Breakpoint) => {
  const [match, setMatch] = useState(matches(breakpoint));

  useLayoutEffect(() => {
    if (!("matchMedia" in window)) {
      return undefined;
    }

    const track = () => {
      const aux = matches(breakpoint);

      if (aux !== match) {
        setMatch(aux);
      }
    };

    window.addEventListener("resize", track);

    return () => {
      return window.removeEventListener("resize", track);
    };
  });

  return match;
};
